export default {
    allSdgs: [],
    showSdgs: {},
    sdgsDeleteId: '',
    pagination: {},
    searchQuery: "",
    }